import { Routes } from '@angular/router';

import { seoRouteData } from '../../services/seo/seo-route-data';

export const automationRoutes: Routes = [
  {
    path: 'contact-center/:communicationId',
    loadComponent: () =>
      import('./pages/contact-center/contact-center.component').then((m) => m.ContactCenterComponent),
    data: { seo: seoRouteData.contactCenter },
  },
];
